import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { Link } from "react-router-dom";
import SearchPage from "../SearchPage/SearchPage";
import { formatImagePath } from "../../helpers/image";

const HaederMenuPopup = () => {
	const [hoveredImage, setHoveredImage] = useState(null);
	const [dialogOpen, setDialogOpen] = useState(false);

	const handleOpen = () => {
		setDialogOpen(true);
	};

	const handleClose = () => {
		setDialogOpen(false);
	};

	const handleHover = (imageUrl) => {
		setHoveredImage(imageUrl);
	};
	const handleMenuItemClick = () => {
		handleClose();
	};

	return (
		<div style={{ display: "flex" }}>
			<img
				src="/img/homepage/nav-hamburger-icon.png"
				alt=""
				onClick={handleOpen}
				style={{
					cursor: "pointer",
					width: "60%",
					height: "100%",
					marginLeft: "10px",
				}}
			/>
			<Dialog
				open={dialogOpen}
				onClose={() => setDialogOpen(false)}
				className={`headermenu-popup-secion ${dialogOpen ? "open" : ""} ${
					dialogOpen ? "dialog-slide-in" : "dialog-slide-out"
				}`}
			>
				<DialogTitle>
					<Link to={"/"} onClick={handleMenuItemClick}>
						<img
							width="200px"
							src="/img/logo/kpj_logo.png"
							alt=""
							loading="lazy"
						/>
					</Link>
					<IconButton
						aria-label="close"
						onClick={handleClose}
						style={{ position: "absolute", top: "8px", right: "8px" }}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<div className="two-columns-grid">
						<div className="first-coloumn">
							<div className="first-coloumn-sub">
								<Link
									to="/our-hospitals"
									className="hover-trigger"
									onMouseEnter={() =>
										handleHover("./../img/header/hospital-header.png")
									}
									onClick={handleMenuItemClick}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Hospitals
								</Link>
							</div>
							<div className="first-coloumn-sub">
								<Link
									to="/doctor"
									className="hover-trigger"
									onMouseEnter={() =>
										handleHover("./../img/header/doctor-header.png")
									}
									onClick={handleMenuItemClick}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Doctors
								</Link>
							</div>
							<div className="first-coloumn-sub">
								<Link
									to="https://coe.kpjhealth.com.my/"
									className="hover-trigger"
									onMouseEnter={() =>
										handleHover("./../img/header/speciality-header.png")
									}
									onClick={handleMenuItemClick}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Excellence Centres
								</Link>
							</div>
							<div className="first-coloumn-sub">
								<Link
									to="/speciality-centre"
									className="hover-trigger"
									onMouseEnter={() =>
										handleHover("./../img/header/speciality-header.png")
									}
									onClick={handleMenuItemClick}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Our Speciality Centres
								</Link>
							</div>
							<div className="first-coloumn-sub">
								<Link
									to="/kpj-cares-card-program"
									className="hover-trigger"
									onMouseEnter={() =>
										handleHover("./../img/header/cares-header.png")
									}
									onClick={handleMenuItemClick}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									KPJ Cares
								</Link>
							</div>
							<div className="first-coloumn-sub">
								<Link
									to="/campaigns-promotions"
									className="hover-trigger"
									onMouseEnter={() =>
										handleHover("./../img/header/campro-header.png")
									}
									onClick={handleClose}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Campaigns & Promotions
								</Link>
							</div>
							<div className="first-coloumn-sub">
								<Link
									to="/events"
									className="hover-trigger"
									onMouseEnter={() =>
										handleHover("./../img/header/event-header.png")
									}
									onClick={handleClose}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Events
								</Link>
							</div>
							<div className="first-coloumn-sub">
								<Link
									to="/gl-application"
									className="hover-trigger"
									onMouseEnter={() =>
										handleHover("./../img/header/apply-for-gl.png")
									}
									onClick={handleClose}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Apply for GL
								</Link>
							</div>
							<div className="first-coloumn-sub">
								<Link
									to="https://healthshoppe.com.my/"
									className="hover-trigger"
									onMouseEnter={() =>
										handleHover("./../img/header/health-shoppe.png")
									}
									onClick={handleClose}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Healthshoppe
								</Link>
							</div>
							<div className="first-coloumn-sub">
								<Link
									to="/mccn/our-collaboration"
									className="hover-trigger"
									onMouseEnter={() => handleHover("./../img/header/mayo.jpg")}
									onClick={handleClose}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Mayo Clinic Care Network
								</Link>
							</div>
						</div>
						<div
							className="second-coloumn"
							style={{
								display: "flex",
								flexDirection: "column",
								flexWrap: "wrap",
								alignContent: "space-around",
							}}
						>
							<div className="second-coloumn-sub">
								<Link
									to="/home"
									onClick={handleClose}
									style={{
										fontSize: "35px",
										fontWeight: "500",
										color: "#000000",
									}}
								>
									Home
								</Link>
							</div>
							<div
								className="image-container"
								style={{
									marginTop: "20px",
									width: "500px",
									height: "350px",
									backgroundImage: `url(${formatImagePath(hoveredImage)})`,
									backgroundSize: "100%",
									backgroundRepeat: "no-repeat",
									transition: "background-image 0.3s ease-in-out",
								}}
							/>
						</div>
					</div>
				</DialogContent>
				<DialogActions>
					<div className="row">
						<div className="col-xl-6 col-lg-6 col-md-6">
							<ul>
								<li>
									<a href="https://www.facebook.com/KPJHealthcareOfficial">
										<i
											className="fab fa-facebook-f"
											style={{ fontSize: "24px" }}
										></i>
									</a>
								</li>
								<li>
									<a href="https://www.instagram.com/kpjhealthcareberhadofficial/">
										<i
											className="fab fa-instagram"
											style={{ fontSize: "24px" }}
										></i>
									</a>
								</li>
								<li>
									<a href="https://twitter.com">
										<i
											className="fab fa-twitter"
											style={{ fontSize: "24px" }}
										></i>
									</a>
								</li>
								<li>
									<a href="https://www.linkedin.com/company/kpj-healthcare-bhd/">
										<i
											className="fab fa-linkedin"
											style={{ fontSize: "24px" }}
										></i>
									</a>
								</li>
								<li>
									<a href="https://www.youtube.com/@kpjhealthcaretv">
										<i
											className="fab fa-youtube"
											style={{ fontSize: "24px" }}
										></i>
									</a>
								</li>
							</ul>
						</div>
						<div className="col-xl-6 col-lg-6 col-md-6">
							{/* <Link to="/search"> */}
							<SearchPage />
							{/* </Link> */}
						</div>
					</div>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default HaederMenuPopup;
